import { render } from "./PathGame.vue?vue&type=template&id=096c480c"
import script from "./PathGame.vue?vue&type=script&lang=js"
export * from "./PathGame.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__